import { render, staticRenderFns } from "./DiceStatisticsItem.vue?vue&type=template&id=2b438dcc&scoped=true&"
import script from "./DiceStatisticsItem.vue?vue&type=script&lang=js&"
export * from "./DiceStatisticsItem.vue?vue&type=script&lang=js&"
import style0 from "./DiceStatisticsItem.vue?vue&type=style&index=0&id=2b438dcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b438dcc",
  null
  
)

export default component.exports